module.exports = __webpack_public_path__ + "859f43be20bb92b8a1c84bbca9acd6b2.jpg";